export default function ReportPreparation() {
  return (
    <section className="reportServicePreparing">
      <div className="reportServicePreparing inner">
        <span className="reportServicePreparing eyebrow">Coming Soon</span>
        <h3 className="reportServicePreparing title">
          이 기능은 준비 중입니다.
        </h3>
        <p className="reportServicePreparing description">
          준비가 완료되면 이용할 수 있습니다.
        </p>
      </div>
    </section>
  );
}
